import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
// import ThemeToggle from "./ThemeToggle";

const NAV_ITEMS = [
  { to: "/", label: "홈", end: true },
  { to: "/자가진단", label: "30초 현실진단", end: false },
  { to: "/#자부담계산기", label: "자부담 계산기", end: false },
  { to: "/과정비교", label: "과정비교", end: false },
];

const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-brand-400 dark:focus-visible:ring-offset-gray-950";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const solid = scrolled || open;

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors ${
        solid
          ? "border-b border-gray-200 bg-white/95 backdrop-blur dark:border-gray-800 dark:bg-gray-950/95"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <Link
          to="/"
          className={`flex cursor-pointer items-center gap-2 text-gray-900 transition-opacity hover:opacity-80 dark:text-gray-100 ${focusRing}`}
        >
          <span className="text-lg font-bold tracking-tight">다봄</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${focusRing} ${
                  isActive
                    ? "font-semibold text-brand-700 dark:text-brand-400"
                    : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/#문의"
            className={`whitespace-nowrap rounded-md px-3 py-2 text-sm text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 ${focusRing}`}
          >
            문의
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          {/* <ThemeToggle /> */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "메뉴 닫기" : "메뉴 열기"}
            aria-expanded={open}
            className={`flex h-11 w-11 cursor-pointer items-center justify-center rounded-md text-gray-600 transition-colors hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 md:hidden ${focusRing}`}
          >
            <i
              className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}
              aria-hidden="true"
            />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-gray-200 bg-white px-4 py-3 dark:border-gray-800 dark:bg-gray-950 md:hidden">
          <div className="mx-auto flex max-w-6xl flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors ${focusRing} ${
                    isActive
                      ? "bg-brand-50 font-semibold text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
                      : "text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/#문의"
              className={`rounded-md px-3 py-3 text-sm text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800 ${focusRing}`}
            >
              문의
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}